module.exports = __webpack_public_path__ + "static/img/taisei.0591dddd.jpg";